import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { LoginPage } from "@/features/auth/pages/login-page";

const getEnabledProviders = createServerFn({ method: "GET" }).handler(
  async () => {
    return [
      ...(process.env.GOOGLE_CLIENT_ID && process.env.GOOGLE_CLIENT_SECRET
        ? (["google"] as const)
        : []),
      ...(process.env.FACEBOOK_CLIENT_ID && process.env.FACEBOOK_CLIENT_SECRET
        ? (["facebook"] as const)
        : []),
    ] as Array<"google" | "facebook">;
  },
);

export const Route = createFileRoute("/login")({
  validateSearch: z.object({
    redirectUrl: z.string().optional(),
  }),
  loader: async () => ({
    enabledProviders: await getEnabledProviders(),
  }),
  component: LoginPage,
});
